import { css, cx } from '@repo/pandacss/styled-system/css';
import { type DriverType } from '@repo/supergraph/marketplace/types';
import type { ProductCard } from '@repo/supergraph/roundup/base/types';
import { CdApysDriver } from '../../../CdApysDriver';
import {
  productCardCdApysDriverTooltipClassName,
  productCardDriverTooltipClassName,
} from '../../../disclosureTooltipPopover';
import { ValueTooltip } from './ValueTooltip';

type Props = {
  borderBottom?: boolean;
  driver: DriverType;
  oneYearApyEntity?: ProductCard['oneYearApyEntity'];
  threeYearApyEntity?: ProductCard['threeYearApyEntity'];
  fiveYearApyEntity?: ProductCard['fiveYearApyEntity'];
  renderCdApys?: boolean;
};

export const Driver = ({
  driver,
  borderBottom = false,
  oneYearApyEntity,
  threeYearApyEntity,
  fiveYearApyEntity,
  renderCdApys = false,
}: Props) => {
  const hasMultiAPYDrivers =
    !!oneYearApyEntity?.driverApy?.value ||
    !!threeYearApyEntity?.driverApy?.value ||
    !!fiveYearApyEntity?.driverApy?.value;

  return (
    <div
      key={driver.label}
      className={cx(
        css({
          display: 'flex',
          paddingBlockStart: '2',
          paddingBlockEnd: '2',
        }),
        borderBottom &&
          css({
            borderBottomWidth: 'thin',
            borderBottomStyle: 'solid',
            borderBottomColor: 'neutral.lighter',
          }),
      )}
    >
      <div className={css({ display: 'flex', flexBasis: '[25%]', flexShrink: '0' })}>
        <p className={css({ textStyle: 'textSmall', color: 'neutral.darker' })}>{driver.label}</p>
      </div>
      <div className={css({ marginLeft: '4', width: 'full' })}>
        {renderCdApys && hasMultiAPYDrivers ? (
          <CdApysDriver
            oneYearApyEntity={oneYearApyEntity}
            threeYearApyEntity={threeYearApyEntity}
            fiveYearApyEntity={fiveYearApyEntity}
            dividerSpacing={2}
            tooltipClassName={productCardCdApysDriverTooltipClassName}
          />
        ) : (
          <div className={css({ display: 'flex', flexDirection: 'row' })}>
            <p className={css({ marginRight: '1' })}>{driver.value || 'N/A'}</p>
            {driver.valueTooltip && (
              <ValueTooltip
                driverLabel={driver.label}
                valueTooltip={driver.valueTooltip}
                tooltipClassName={
                  renderCdApys
                    ? productCardCdApysDriverTooltipClassName
                    : productCardDriverTooltipClassName
                }
              />
            )}
          </div>
        )}
        <div>
          {driver.description && (
            <p
              className={css({
                textStyle: 'textSmall',
                lineHeight: 'normal',
                color: 'neutral.darker',
              })}
            >
              {driver.description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
